import { render, staticRenderFns } from "./Forwarder.vue?vue&type=template&id=8039c08a&scoped=true&"
import script from "./Forwarder.vue?vue&type=script&lang=js&"
export * from "./Forwarder.vue?vue&type=script&lang=js&"
import style0 from "./Forwarder.vue?vue&type=style&index=0&id=8039c08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8039c08a",
  null
  
)

export default component.exports